export default "__VITE_ASSET__BO$C27Sf__"